const $ = jQuery.noConflict();

class Tabs {
    constructor(wrapper, tabsLink, tabsControls) {
        this.tabsWrapper = $(wrapper);
        this.tabsLink = $(tabsLink);
        this.tabsControls = this.tabsWrapper.find(tabsControls);
    }
    init() {
        this.tabsLink.on('click', this.toggleTab);
    }
    toggleTab(e) {
        e.preventDefault();

        const el = $(this);
        const targetId = this.hash;
        const wrapper = el.closest('.block-tabs');

        const target = wrapper.find(`.tabs__tab-content[data-tab-id="${targetId}"]`);

        wrapper.find('.tabs__tab-content').removeClass('active');
        wrapper.find('.tabs__link').removeClass('active');

        el.parent().addClass('active');
        target.addClass('active');
    }
}

export default new Tabs('.tabs__link-list-wrapper', '.tabs__link a', '.tab-nav-button');
